import { getData, postData, putData, deleteData } from "../apiClient";

const ItemName = "Amenity";
const API_URL = "amenity";

// get all with pagination
export const GetAll = async ({ page = 1, limit = 10, search = "" }, signal = null) => {
  try {
    const queryParams = new URLSearchParams({
      page: String(page),
      limit: String(limit),
      search: search,
    });

    const result = await getData(`/${API_URL}/?${queryParams}`, {}, {}, signal);

    return {
      success: true,
      ...result,
    };
  } catch (error) {
    console.error(`Get ${ItemName} with pagination API error:`, error);
    return {
      success: false,
      ...error,
    };
  }
};

// get item data with id
export const GetById = async (id) => {
  try {
    const result = await getData(`/${API_URL}/${id}`);
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error(`Get  ${ItemName} data API error:`, error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};

// create item
export const Create = async ({ data }) => {
  try {
    // Don't pass Content-Type header - let axios/FormData set it automatically with boundary
    const result = await postData(`/${API_URL}/`, data, {
      "content-type": "multipart/form-data"
    });
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error(`Create ${ItemName} API error:`, error.status === 400 ? error.error : error.message);
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.data.error : error.message,
        status: error.status,
      },
    };
  }
};

// update item
export const Update = async ({ id, data }) => {
  try {
    // Don't pass Content-Type header - let axios/FormData set it automatically with boundary
    const result = await putData(`/${API_URL}/${id}`, data, {
      "content-type": "multipart/form-data"
    });
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error(`Update ${ItemName} API error:`, error);
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.data.error : error.message,
        status: error.status,
      },
    };
  }
};

// delete item
export const Delete = async ({ id }) => {
  try {
    const result = await deleteData(`/${API_URL}/${id}`);
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error(`Delete ${ItemName} API error:`, error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};

// get features for an amenity
export const GetFeatures = async (amenityId) => {
  try {
    const result = await getData(`/${API_URL}/${amenityId}/features`);
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error(`Get ${ItemName} features API error:`, error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};

// create feature
export const CreateFeature = async ({ data }) => {
  try {
    const result = await postData(`/${API_URL}/feature`, data, { "Content-Type": "application/json" });
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error(`Create ${ItemName} feature API error:`, error.status === 400 ? error.error : error.message);
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.data.error : error.message,
        status: error.status,
      },
    };
  }
};

// update feature
export const UpdateFeature = async ({ id, data }) => {
  try {
    const result = await putData(`/${API_URL}/feature/${id}`, data, { "Content-Type": "application/json" });
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error(`Update ${ItemName} feature API error:`, error);
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.data.error : error.message,
        status: error.status,
      },
    };
  }
};

// delete feature
export const DeleteFeature = async ({ id }) => {
  try {
    const result = await deleteData(`/${API_URL}/feature/${id}`);
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error(`Delete ${ItemName} feature API error:`, error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};
